import { getStripSearch } from "../../utils/WithQs";
import { GetHeaderState } from "../../utils/api";

export default function (state, action) {
  return {
    cardsFilters: cardsFilters(state.cardsFilters, action),
    teasersFilters: teasersFilters(state.teasersFilters, action),
    cards: cards(state.cards, action),
    teasers: teasers(state.teasers, action),
    ui: ui(state.ui, action),
    userCards: userCards(state.userCards, action)
  };
}

function cardsFilters(state, action) {
  if (action.type == "SET_CARDS_SEARCH") {
    return { ...state, ...action.search };
  }
  return state;
}

function teasersFilters(state, action) {
  if (action.type == "SET_TEASERS_SEARCH") {
    return { ...state, ...action.search };
  }
  return state;
}

function cards(state, action) {
  if (action.type == "SET_CARDS_LOADING") {
    return { ...state, loading: action.loading };
  }

  if (action.type == "SET_CARDS") {
    return action.cards;
  }

  return state;
}

function teasers(state, action) {
  if (action.type == "SET_GLOBAL_CHECK") {
    return { ...state, globalCheck: action.globalCheck, checked: [] };
  }

  if (action.type == "SET_TEASER_CHECKED") {
    let checked;

    if (action.checked) {
      checked = [...state.checked, action.tid];
    } else {
      checked = state.checked.filter(id => id != action.tid);
    }

    return { ...state, globalCheck: false, checked };
  }

  if (action.type == "SET_SHOW_URL") {
    return { ...state, showUrl: action.showUrl };
  }

  if (action.type === "SET_SHOW_DISCLAIMER") {
    return { ...state, showDisclaimer: action.showDisclaimer };
  }

  if (action.type == "SET_TEASERS_LOADING") {
    return { ...state, loading: action.loading };
  }

  if (action.type == "SET_TEASERS") {
    return {
      ...state,
      loading: false,
      list: action.teasers,
      total_count: action.total_count,
      page: 1,
      hasMore: action.teasers.length != 0
    };
  }

  if (action.type == "SET_TOTAL_STAT") {
    return {
      ...state,
      total_stat: action.total_stat
    };
  }

  if (action.type == "APPEND_TEASERS") {
    const existingIds = new Set(state.list.map(item => item.id));

    // Фильтруем новые тизеры, оставляя только те, чьи id отсутствуют в существующем списке.
    // https://tasks.eqwile.team/browse/DEV-1364 - решили делать на фронте
    const uniqueTeasers = action.teasers.filter(
      teaser => !existingIds.has(teaser.id)
    );

    return {
      ...state,
      loading: false,
      list: [...state.list, ...uniqueTeasers],
      hasMore: action.teasers.length != 0
    };
  }

  if (action.type == "SET_TEASERS_PAGE") {
    return { ...state, page: action.page, hasMore: true };
  }

  if (action.type == "TEASER_CHANGE") {
    const list = state.list.map(teaser => {
      if (teaser.id == action.tid) {
        return { ...teaser, ...action.payload };
      }
      return teaser;
    });
    return { ...state, list };
  }

  if (action.type == "SET_PAYOUT_MODE") {
    return { ...state, payoutMode: action.payoutMode };
  }

  if (action.type == "MASS_ACTION_DONE") {
    return {
      ...state,
      checked: [],
      list: [],
      globalCheck: false,
      page: 1,
      reloadCnt: state.reloadCnt + 1
    };
  }

  if (action.type == "SET_TEASERS_SEARCH") {
    return { ...state, list: [], hasMore: true };
  }

  if (action.type == "APPEND_NEW_TEASERS") {
    const newTeasers = action.teasers.map(t => {
      t.isNew = true;
      return t;
    });

    return { ...state, list: [...newTeasers, ...state.list] };
  }

  return state;
}

function ui(state, action) {
  if (action.type == "TOGGLE_CARDS_OPEN") {
    return { ...state, cardsOpen: !state.cardsOpen };
  }
  if (action.type == "SET_MASS_COPY_VISIBLE") {
    return { ...state, massCopy: action.visible };
  }
  if (action.type == "SET_CONFIRM_TYPE") {
    return { ...state, confirmType: action.confirmType };
  }

  return state;
}

function userCards(state, action) {
  if (action.type == "SET_USER_CARDS") {
    return { cards: action.cards, firstLoadDone: true };
  }
  return state;
}

export function getInitialState(search) {
  const cardsFilters = getStripSearch(search, "cards_");
  const teasersFilters = getStripSearch(search, "teasers_");
  const { fixed } = GetHeaderState();

  return {
    cardsFilters,
    teasersFilters,
    cards: {
      counts: {},
      cards: [],
      user_cards_cnt: 0,
      loading: false
    },
    teasers: {
      list: [],
      total_count: 0,
      total_stat: {
        clicks: 0,
        ctr: 0,
        shows: 0
      },
      loading: false,
      page: 1,
      hasMore: true,
      globalCheck: false,
      checked: [],
      showUrl: false,
      payoutMode: false,
      reloadCnt: 0
    },
    ui: {
      refresh: false,
      confirmType: null,
      massCopy: false,
      cardsOpen: !fixed
    },
    userCards: {
      cards: [],
      firstLoadDone: false
    }
  };
}
